import CheckBox from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlank from '@mui/icons-material/CheckBoxOutlineBlank';
import {
  Autocomplete,
  Checkbox,
  TextField,
  type AutocompleteProps,
} from '@mui/material';

import React from 'react';
export interface Option {
  label: string;
  value: string;
}

// interface StringFilterDropdownProps {
//   options: Option[];
//   label: string;
//   placeholder: string;
//   onChange: (value: Option[]) => void;
// }

// interface StringFilterDropdownProps {
//   value: string[];
//   options: Option[];
//   label: string;
//   onChange: (value: Option[]) => void;
//   getOptionLabel?: (value: Option) => string;
// }

interface StringFilterDropdownProps
  extends Omit<
    AutocompleteProps<
      string, // type for "value"
      true, // multiple: true
      false, // disableClearable: true
      false // freeSolo: true
      // boolean // typeof ReportChip // for renderTags
    >,
    'onChange' | 'renderInput' | 'getOptionLabel'
  > {
  label: string;
  getOptionLabel: (value: string) => string;
  onChange: (values: string[]) => void; // Custom redefinition of Autocomplete's onChange
}

const icon = <CheckBoxOutlineBlank fontSize="small" />;
const checkedIcon = <CheckBox fontSize="small" />;

const StringFilterDropdown: React.FC<StringFilterDropdownProps> = ({
  options,
  label,
  value,
  onChange,
  getOptionLabel,
  ...rest
}) => {
  return (
    <Autocomplete
      value={value}
      multiple
      size="small"
      disableCloseOnSelect
      fullWidth
      options={options}
      onChange={(event, values) => {
        onChange(values);
      }}
      getOptionLabel={getOptionLabel}
      renderOption={(props, option, { selected }, { getOptionLabel }) => {
        const { key, ...optionProps } = props;
        return (
          <li key={key} {...optionProps}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {getOptionLabel(option)}
          </li>
        );
      }}
      renderInput={(params) => <TextField {...params} label={label} />}
      {...rest}
    />
  );
};
export default StringFilterDropdown;
